export default __webpack_public_path__ + "static/media/avatarC4.bf8cbe63.png";